export default "__VITE_PUBLIC_ASSET__d6916be0__"